/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import React, { useCallback, useState } from "react"
import { NavigableBreadcrumbLink } from "../../../components/page_breadcrumbs/navigable_breadcrumb_link";
import {
  Box,
  Breadcrumbs,
  Typography,
  FormControl,
  Select,
  Alert,
  Tooltip,
  IconButton,
  Drawer,
  Paper,
  InputAdornment,
} from "@mui/material"
import {
  StyledBreadCrumbContainer,
  StyledLink,
  StyledInputLabel,
  StyledTextField,
  StyledDiv,
  StyledFormField,
  StyledEmployeeDetails,
  StyledInput,
  filterContainerStyles,
  filterGroupStyles,
  typographyStyles,
  formControlStyles,
  menuPropStyles,
  selectFieldStyles,
  StyledMenuItem,
  actionGroupStyles,
  StyledTypography,
  StyledIgnoreButton,
} from "./styles"
import { FilterContainer } from "../../../components/filter_container"
import { UpdateButton } from "../../../components/update_button"
import { MenuHeading } from "../../../components/menu_heading"
import { DropdownInfiniteLoader } from "../../../components/dropdown_infinite_loader"
import { useInfiniteQuery, useQuery, useQueryClient, keepPreviousData } from "@tanstack/react-query"
import api from "../../../api"
import authenticatedFetch from "../../../api/authenticatedFetch"
import { Loader } from "../../../components/loader"
import { IndexTable } from "../../../components/index_table"
import camelize from '../../../utils/camelize'
import { useNotificationContext } from "../../../contexts/notificationContext"
import DropdownSearchBar from "../../../components/dorpdown_searchbar"
import { SelectedMenuItem } from '../../../components/selected_menu_item/index'
import { buildQueryParams } from "../../../utils/buildQueryParams"
import dayjs from "dayjs"
import AddIcCallIcon from '@mui/icons-material/AddIcCall';
import { checkAdmin } from "../../../utils/checkAdmin"
import { useSelector } from "react-redux"
import {
  StyledButtonContainer,
  StyledCancelButton,
  StyledCreateTitle,
  StyledFormContainer,
  StyledFormFieldText,
} from "../../restaurant_groups/styles"
import { LoadingSpinner } from "../../../components/loading_spinner"
import {
  StyledAddButton,
  StyledCrossButton,
  StyledHelperText,
  StyledPhoneField,
  StyledSearchIconButton
} from "../../network_guests/styles"
import ClearIcon from '@mui/icons-material/Clear';
import { ResetButton } from "../../../components/reset_button"
import SearchIcon from '@mui/icons-material/Search';
import { useLocation } from "react-router-dom"
import { StyledFilterCancel } from "../../dashboard/styles"
import { FailedRestaurantModal } from "../../../components/failed_restaurant_modal"
import { validatePhoneNumber } from "../../../utils/validatePhoneNumber"
import { Query_Keys } from "../../../lib/queryKeys"
import IgnoredEmployees from "./ignored_employees"
import IgnoreEmployeeDialog from "./ignore_employee_dialog"
import { hasSingleItem } from "../../../utils/hasSingleItem"
import { useOtMutation } from "../../../hooks/mutations/useOtMutation"
import { employeeVisibilityMutationKeyGroups } from "../../../hooks/mutations/queryKeyGroups/employeeVisibilityMutationKeys"
import { PerPage } from "../../../constants/perPage"
import { resetPageAfterDeletion } from "../../../utils/resetPageAfterDeletion"
import {
  getDropdownNextPageParam,
  mergeUniqueByKey,
  normalizeRestaurant,
  normalizeRestaurantGroup,
} from "../../../utils/dropdownInfiniteQuery"
import { useDebounce } from "../../../utils/useDebounce"
import { useInfiniteScrollObserver } from "../../../hooks/useInfiniteScrollObserver"
import { StyledSearchBar } from "../styles";

const drawerWidth = 400
const EMPTY_FILTERS = {
  restaurant_group_id: '',
  restaurant_ids: [],
}

export const EmployeeVisibility = () => {
  const [restaurantIds, setRestaurantIds] = useState([])
  const location = useLocation()
  const initialFilters = {
    restaurant_ids: location?.state?.restaurantId || [],
    restaurant_group_id: location?.state?.restaurantGroupId || '',
  }
  const [appliedFilters, setAppliedFilters] = useState(initialFilters);
  const [filtersChanged, setFiltersChanged] = React.useState(false)
  const [page, setPage] = React.useState(1)
  const [itemsPerPage, setItemsPerPage] = React.useState(25)
  const [restaurantSearch, setRestaurantSearch] = React.useState("");
  const showNotification = useNotificationContext();
  const [csvLoading, setCsvLoading] = useState(false)
  const [drawerOpen, setDrawerOpen] = useState(false)
  const [phoneNumber, setPhoneNumber] = useState('')
  const [phoneNumberError, setPhoneNumberError] = useState('')
  const [employee, setEmployee] = useState('')
  const { admin } = useSelector((state) => state.admin);
  const superAdmin = checkAdmin(admin?.formatted_roles)
  const [status, setStatus] = useState(false)
  const queryClient = useQueryClient();
  const [networkGuestFetched, setNetworkGuestFetched] = useState(false)
  const [networkGuestExist, setNetworkGuestExist] = useState(false)
  const [networkGuests, setNetworkGuests] = useState([]);
  const [networkGuestFetchLoading, setNetworkGuestFetchLoading] = useState(false)
  const [selectedNetworkGuestIds, setSelectedNetworkGuestIds] = useState([]);
  const [restaurantGroupSearch, setRestaurantGroupSearch] = useState('')
  const [restaurantGroupId, setRestaurantGroupId] = useState(null)
  const [errorOpen, setErrorOpen] = useState(false)
  const [failedRestaurants, setFailedRestaurants] = useState([])
  const [successfulRestaurantsCount, setSuccessfulRestaurantsCount] = useState(0)
  const [lastHandledAt, setLastHandledAt] = useState(null)
  const [employeesToIgnore, setEmployeesToIgnore] = useState([])
  const [selectedEmployeeIds, setSelectedEmployeeIds] = useState([])
  const [loading, setLoading] = useState(false)
  const [viewType, setViewType] = useState('unignored')
  const [shouldShowFetchFailures, setShouldShowFetchFailures] = useState(false)
  const [sortBy, setSortBy] = useState('first_name')
  const [sortOrder, setSortOrder] = useState('asc')
  const [restaurantOptionsCache, setRestaurantOptionsCache] = useState([])
  const [restaurantGroupOptionsCache, setRestaurantGroupOptionsCache] = useState([])
  const [nameSearch, setNameSearch] = useState("")
  const debouncedRestaurantGroupSearch = useDebounce(restaurantGroupSearch.trim(), 300)
  const debouncedRestaurantSearch = useDebounce(restaurantSearch.trim(), 300)
  const debouncedNameSearch = useDebounce(nameSearch.trim(), 300)
  const [ignoredEmployeeCount, setIgnoredEmployeeCount] = useState(null)
  const [isIgnoredEmployeesFetching, setIsIgnoredEmployeesFetching] = useState(false)
  const [hasIgnoredEmployeeSearch, setHasIgnoredEmployeeSearch] = useState(false)

  const fetchRestaurantGroupList = async ({ pageParam = 1 }) => {
    const response = await api.get("/v1/admin/dropdowns/restaurant_groups_list", {
      params: {
        page: pageParam,
        per_page: PerPage,
        search: debouncedRestaurantGroupSearch || undefined,
      },
    });
    return response?.data?.map(normalizeRestaurantGroup) || [];
  };

  const {
    data: restaurantGroups = [],
    isFetching: restaurantGroupFetching,
    isFetchingNextPage: restaurantGroupsFetchingNextPage,
    fetchNextPage: fetchNextRestaurantGroupsPage,
    hasNextPage: hasNextRestaurantGroupsPage,
  } = useInfiniteQuery({
    queryKey: Query_Keys.restaurant_groups_dropdown({ search: debouncedRestaurantGroupSearch }),
    queryFn: fetchRestaurantGroupList,
    initialPageParam: 1,
    getNextPageParam: getDropdownNextPageParam,
    select: (data) => data.pages.flat(),
    staleTime: 10 * 60 * 1000,
    placeholderData: keepPreviousData,
  });

  const fetchRestaurants = async ({ pageParam = 1 }) => {
    const res = await api.get('/v1/admin/dropdowns/restaurants_list', { params: { 
      page: pageParam,
      per_page: PerPage,
      search: debouncedRestaurantSearch || undefined,
      restaurant_group_ids: restaurantGroupId ,
      toast_connection_status: 'verified',
    }})
    return res?.data?.map(normalizeRestaurant) || []
  }

  const {
    data: restaurants = [],
    isFetching: restaurantFetching,
    isFetchingNextPage: restaurantsFetchingNextPage,
    fetchNextPage: fetchNextRestaurantsPage,
    hasNextPage: hasNextRestaurantsPage,
  } = useInfiniteQuery({
    queryKey: Query_Keys.restaurants_dropdown({
      restaurant_group_id: restaurantGroupId,
      toast_connection_status: 'verified',
      search: debouncedRestaurantSearch,
    }),
    queryFn: fetchRestaurants,
    initialPageParam: 1,
    getNextPageParam: getDropdownNextPageParam,
    select: (data) => data.pages.flat(),
    staleTime: 10 * 60 * 1000
  })

  const { rootRef: restaurantGroupMenuRef, targetRef: restaurantGroupLoaderRef } = useInfiniteScrollObserver({
    fetchNextPage: fetchNextRestaurantGroupsPage,
    hasNextPage: hasNextRestaurantGroupsPage,
    isFetchingNextPage: restaurantGroupsFetchingNextPage,
  })

  const { rootRef: restaurantMenuRef, targetRef: restaurantLoaderRef } = useInfiniteScrollObserver({
    fetchNextPage: fetchNextRestaurantsPage,
    hasNextPage: hasNextRestaurantsPage,
    isFetchingNextPage: restaurantsFetchingNextPage,
  })

  const formattedFilters = (nameSearchTerm = '') => {
    const params = {}

    if (nameSearchTerm) {
      params.name_search = nameSearchTerm
    }

    return params;
  }

  const hasActiveEmployeeFilters = Boolean(appliedFilters?.restaurant_group_id) || (appliedFilters?.restaurant_ids || []).length > 0

  const fetchEmployeeVisibility = async () => {
    const newFormattedFilters = formattedFilters(debouncedNameSearch);
    if ((appliedFilters?.restaurant_ids || []).length === 0 && !appliedFilters?.restaurant_group_id) return;
    const response = await api.post('/v1/admin/employees/fetch_employee_visibility', {
      restaurant_ids: appliedFilters?.restaurant_ids || [],
      per_page: itemsPerPage,
      page: page,
      restaurant_group_id: appliedFilters?.restaurant_group_id,
      sort_by: sortBy,
      sort_order: sortOrder,
      ...newFormattedFilters,
    })
    const errorRestaurants = response?.data?.meta?.failed_restaurants
    const successfulRestaurantsCount = response?.data?.meta?.successful_restaurants_count ?? 0
    return {
      data: response?.data?.data,
      pageCount: response?.headers["total-count"],
      errorRestaurants,
      successfulRestaurantsCount,
    }
  }

  const { data: employee_visibility, error, isFetching, dataUpdatedAt: employee_visibilityUpdatedAt } = useQuery({
    queryKey: Query_Keys.employee_visibility({
      queryFilter: appliedFilters,
      page: page,
      itemsPerPage: itemsPerPage,
      sortBy,
      sortOrder,
      nameSearch: debouncedNameSearch,
    }),
    queryFn: fetchEmployeeVisibility,
    staleTime: 10 * 60 * 1000,
    enabled: hasActiveEmployeeFilters && viewType === 'unignored',
    placeholderData: keepPreviousData,
  })

  const { mutateAsync: addEmployeePhoneNumberMutation } = useOtMutation({
    mutationFn: async (payload) => await api.post('/v1/admin/employees/manual_employee_override', payload),
    invalidateKeys: [...employeeVisibilityMutationKeyGroups.addPhoneNumber],
    onSuccess: () => {
      setDrawerOpen(false)
      setStatus(false)
      showNotification("Employee's phone number added successfully", 'success')
      setPhoneNumber('')
      setPhoneNumberError('')
      handleClearNetworkGuest()
      resetPageAfterDeletion({ totalCount: employee_visibility?.pageCount, removed: 1, page, itemsPerPage, setPage })
    },
    onError: (error) => {
      setPhoneNumberError(error?.response?.data?.errors);
      setStatus(false)
    }
  });

  const handleAdd = async () => {
    setStatus(true);

    try {
      await addEmployeePhoneNumberMutation({
        restaurant_id: employee?.restaurant_id,
        phone_number: phoneNumber,
        employee_guid: employee?.employee_guid,
        network_guest_id: selectedNetworkGuestIds?.[0]
      });
    } catch {
      // Handled in onError
    }
  }

  const handleDrawerClose = () => {
    setDrawerOpen(false)
    setPhoneNumber('')
    setPhoneNumberError('')
    handleClearNetworkGuest()
  }

  const handleClose = () => {
    setErrorOpen(false)
    setFailedRestaurants([])
    setSuccessfulRestaurantsCount(0)
  }

  React.useEffect(() => {
    setRestaurantGroupOptionsCache((currentOptions) => mergeUniqueByKey(currentOptions, restaurantGroups, 'label'));
  }, [restaurantGroups])

  React.useEffect(() => {
    setRestaurantOptionsCache((currentOptions) => mergeUniqueByKey(currentOptions, restaurants, 'id'));
  }, [restaurants])

  const hasSingleAvailableRestaurantGroup = !debouncedRestaurantGroupSearch && hasSingleItem(restaurantGroups)
  const hasSingleAvailableRestaurant = !debouncedRestaurantSearch && hasSingleItem(restaurants)

  React.useEffect(() => {
    if (hasSingleAvailableRestaurantGroup) {
      setRestaurantGroupId(restaurantGroups?.[0]?.label);
      setFiltersChanged(true)
    }
  }, [hasSingleAvailableRestaurantGroup, restaurantGroups])

  React.useEffect(() => {
    if (hasSingleAvailableRestaurant) {
      setRestaurantIds([restaurants?.[0]?.id]);
      setFiltersChanged(true)
    }
  }, [hasSingleAvailableRestaurant, restaurants])

  React.useEffect(() => {
    setSelectedEmployeeIds([])
  }, [viewType, page])

  React.useEffect(() => {
    if (error?.response?.data?.errors?.failed) {
      showNotification(error?.response?.data?.errors?.failed, 'error')
    }
  }, [error])

  React.useEffect(() => {
    if (!shouldShowFetchFailures) return
    if (!employee_visibilityUpdatedAt || employee_visibilityUpdatedAt === lastHandledAt) return

    if (itemsPerPage !== 25) return
    if (employee_visibility?.errorRestaurants?.length > 0 && page === 1) {
      setErrorOpen(true)
      setFailedRestaurants(employee_visibility?.errorRestaurants)
      setSuccessfulRestaurantsCount(employee_visibility?.successfulRestaurantsCount ?? 0)
    }

    setLastHandledAt(employee_visibilityUpdatedAt)
    setShouldShowFetchFailures(false)
  }, [employee_visibility, page, lastHandledAt, itemsPerPage, employee_visibilityUpdatedAt, shouldShowFetchFailures])

  const handleRestaurantGroupChange = (event) => {
    setFiltersChanged(true)
    setRestaurantGroupId(event.target.value)
    setRestaurantIds([])
    setSelectedEmployeeIds([])
  }

  const handleRestaurantChange = (event) => {
    setFiltersChanged(true);
    setRestaurantIds(event.target.value);
    setSelectedEmployeeIds([])
  };

  const handleChange = () => {
    setShouldShowFetchFailures(true)
    setAppliedFilters({
      restaurant_group_id: restaurantGroupId,
      restaurant_ids: restaurantIds,
      per_page: 25,
      page: 1,
    });
    setItemsPerPage(25);
    setPage(1);
    setFiltersChanged(false);
    setSelectedEmployeeIds([])
  };

  const handleSort = (nextSortBy, nextSortOrder) => {
    setShouldShowFetchFailures(false)
    setSortBy(nextSortBy)
    setSortOrder(nextSortOrder)
    setPage(1)
  }

  const handleReset = () => {
    setFiltersChanged(false);
    setRestaurantGroupSearch('');
    setRestaurantGroupId('');
    setRestaurantSearch('');
    setRestaurantIds([]); 
    setAppliedFilters(EMPTY_FILTERS);
    setSortBy('first_name');
    setSortOrder('asc');
    setItemsPerPage(25);
    setPage(1);
  };

  const handleExportCsv = async () => {
    try {
      setCsvLoading(true);
      const query = buildQueryParams({ restaurant_ids: restaurantIds, restaurant_group_id: restaurantGroupId })
      const url = `${process.env.REACT_APP_API_BASE_URL}/v1/admin/csv_reports/export?report=employee_without_number&${query}`;

      const { response } = await authenticatedFetch(url, {
        method: 'GET',
        defaultErrorMessage: 'Failed to download CSV'
      });

      const blob = await response.blob();
      const downloadUrl = window.URL.createObjectURL(blob);

      const a = document.createElement('a');
      a.href = downloadUrl;
      let date = new Date
      let filename = `employee_without_number_${dayjs(date).format('YYYY-MM-DD')}.csv`

      a.download = filename;
      a.click();

      window.URL.revokeObjectURL(downloadUrl);

      showNotification('CSV downloaded successfully', 'success');
    } catch (error) {
      console.error('CSV download error:', error);
      showNotification(error?.message || 'Failed to download CSV', 'error');
    } finally {
      setCsvLoading(false);
    }
  }

  const handleClearNetworkGuest = () => {
    setNetworkGuestExist(false)
    setNetworkGuestFetched(false)
    setPhoneNumber('')
    setNetworkGuests([]);
    setSelectedNetworkGuestIds([])
  }

  const searchNetworkGuest = async () => {
    if (!validatePhoneNumber(phoneNumber)) {
      setPhoneNumberError('Phone number is required')
      return;
    } else {
      setNetworkGuestFetchLoading(true)
      await api.get('/v1/admin/network_guests/find_guest_by_number', {
        params: {
          phone_number: phoneNumber,
          multiple: true
        }
      })
        .then((res) => {
          const guests = res?.data || [];
          setNetworkGuests(guests);
          setNetworkGuestExist(guests.length > 0);

          if (guests.length > 0) {
            setSelectedNetworkGuestIds([guests[0].id]);
          } else {
            setSelectedNetworkGuestIds([]);
          }
        })
        .catch(() => {
          setNetworkGuestExist(false)
          setSelectedNetworkGuestIds([])
        })
      setNetworkGuestFetched(true)
      setNetworkGuestFetchLoading(false)
    }
  }

  const { mutateAsync: ignoreEmployeeMutation } = useOtMutation({
    mutationFn: async (payload) => await api.post('/v1/admin/employees/ignore', payload),
    invalidateKeys: [...employeeVisibilityMutationKeyGroups.ignoreEmployee],
    errorMessage: () => null,
    onSuccess: () => {
      showNotification(employeesToIgnore?.length > 1 ? 'Employees ignored successfully' : 'Employee ignored successfully', 'success')
      if (employeesToIgnore?.some((employeeRecord) => employeeRecord?.employee_guid === employee?.employee_guid) && drawerOpen) {
        setDrawerOpen(false);
      }
      resetPageAfterDeletion({ totalCount: employee_visibility?.pageCount, removed: employeesToIgnore?.length || 1, page, itemsPerPage, setPage })
      setEmployeesToIgnore([])
      setSelectedEmployeeIds([])
      setLoading(false)
    },
    onError: (error) => {
      showNotification(error?.response?.data?.errors?.[0] || 'Failed to ignore employee', 'error')
      setLoading(false)
    }
  });

  const handleIgnoreEmployee = async (reason) => {
    if (!employeesToIgnore?.length) return

    setLoading(true)
    try {
      await ignoreEmployeeMutation({
        employees: employeesToIgnore.map((employeeRecord) => ({
          employee_guid: employeeRecord?.employee_guid,
          employee_name: `${employeeRecord?.first_name || ''} ${employeeRecord?.last_name || ''}`.trim(),
          email: employeeRecord?.email,
        })),
        reason: reason || undefined,
        restaurant_group_id: appliedFilters?.restaurant_group_id
      });
    } catch {
      // Handled in onError
    }
  }

  const getRestaurantGroupName = (id) => {
    const restaurantGroup = restaurantGroupOptionsCache?.find((res) => res.label === id)
    return restaurantGroup?.value ? restaurantGroup?.value : ''
  }

  const getRestaurantDisplayValue = () => {
    if (restaurantIds?.length === 1 && restaurantOptionsCache) {
      const restaurant = restaurantOptionsCache.find((res) => res.id === restaurantIds?.[0])
      return restaurant ? restaurant?.name : ''
    }

    return `${restaurantIds?.length} Restaurants Selected`;
  }

  const handleRestaurantClear = () => {
    setRestaurantIds([])
    setFiltersChanged(true)
    setSelectedEmployeeIds([])
  }

  const handleRestaurantGroupClear = () => {
    setRestaurantGroupId(null)
    setFiltersChanged(true)
    setSelectedEmployeeIds([])
  }

  const handleSearch = useCallback((searchQuery) => {
    setNameSearch(searchQuery)
    setPage(1)
    if (viewType === 'ignored' && searchQuery) setHasIgnoredEmployeeSearch(true)
  }, [viewType])

  const TableColumns = [
    { key: 'first_name', sortable: true },
    { key: 'last_name', sortable: true },
    { key: 'employee_id', sortable: true },
    { key: 'restaurant', sortable: true },
    { key: 'email', sortable: true },
    { key: 'actions', sortable: false }
  ]

  const columns = TableColumns?.map((column) => {
    return {
      key: column.key,
      label: camelize(column.key),
      sortable: column.sortable
    };
  });

  const TableRows = (data) => {
    return data?.map((record) => {
      return {
        id: record?.employee_guid,
        first_name: record?.first_name,
        last_name: record?.last_name,
        employee_id: record?.employee_id,
        restaurant: record?.restaurant_name,
        email: record?.email,
        actions: <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <Tooltip
            title={'Add Phone Number'}
            arrow
          >
            <span>
              <IconButton
                disabled={!(superAdmin?.role === 'admin')}
                onClick={() => {
                  setDrawerOpen(true)
                  setEmployee(record)
                }}>
                <AddIcCallIcon
                  sx={{
                    color: !(superAdmin?.role === 'admin') ? "#e0e0e0" : "#707070",
                    cursor: "pointer",
                  }}
                />
              </IconButton>
            </span>
          </Tooltip>
        </Box>
      };
    });
  };

  const rows = TableRows(employee_visibility?.data);
  const selectedEmployees = (employee_visibility?.data || []).filter((record) => selectedEmployeeIds.includes(record.employee_guid))

  const hasIgnoredEmployeesLoaded = ignoredEmployeeCount !== null

  const disableSearch =
    viewType === 'ignored'
      ? !hasIgnoredEmployeesLoaded && !hasIgnoredEmployeeSearch
      : !hasActiveEmployeeFilters || !employee_visibility?.data

  return (
    <React.Fragment>
      <Box
        sx={{
          height: "100%",
          width: drawerOpen ? 'calc(100% - 400px)' : '100%',
          overflowY: "scroll",
          overflowX: 'hidden'
        }}
      >
        <StyledBreadCrumbContainer>
          <Breadcrumbs>
            <NavigableBreadcrumbLink LinkComponent={StyledLink} label="Home" to="/admin/dashboard" />
            <StyledLink color={"#515152"}>Reports</StyledLink>
            <StyledLink color={"#515152"}>Employee Reports</StyledLink>
            <StyledLink color={"#515152"}>Employees Without Number Report</StyledLink>
          </Breadcrumbs>
        </StyledBreadCrumbContainer>

        <FilterContainer>
          <Box sx={filterContainerStyles}>
            <Box sx={filterGroupStyles}>
              <React.Fragment>
                <Typography
                  variant="body2"
                  sx={typographyStyles}
                >
                  View
                </Typography>
                <FormControl
                  size="small"
                  sx={formControlStyles}
                >
                  <Select
                    data-testid="show-select"
                    size="small"
                    displayEmpty
                    MenuProps={menuPropStyles}
                    sx={selectFieldStyles}
                    value={viewType}
                    onChange={(e) => {
                      setViewType(e.target.value)
                      setNameSearch('')
                    }}
                  >
                    <StyledMenuItem value={'unignored'}>Employees</StyledMenuItem>
                    <StyledMenuItem value={'ignored'}>Ignored Employees</StyledMenuItem>
                  </Select>
                </FormControl>

                {viewType === 'unignored' && (
                  <React.Fragment>
                    <FormControl
                      size="small"
                      sx={formControlStyles}
                    >
                      <StyledInputLabel>Restaurant Group</StyledInputLabel>
                      <Select
                        data-testid='restaurant-group-filter'
                        size="small"
                        label="Restaurant Group"
                        MenuProps={{ ...menuPropStyles, PaperProps: { ref: restaurantGroupMenuRef } }}
                        sx={selectFieldStyles}
                        onClose={() => setTimeout(() => setRestaurantGroupSearch(''), 1000)}
                        onChange={handleRestaurantGroupChange}
                        value={restaurantGroupId || ''}
                        renderValue={() => getRestaurantGroupName(restaurantGroupId)}
                        endAdornment={
                          !hasSingleAvailableRestaurantGroup && restaurantGroupId ? (
                            <StyledFilterCancel>
                              <IconButton
                                edge='end'
                                size="small"
                                disableRipple
                                onClick={handleRestaurantGroupClear}
                              >
                                <ClearIcon sx={{ fontSize: '20px' }} />
                              </IconButton>
                            </StyledFilterCancel>
                          ) : null
                        }
                      >
                        <DropdownSearchBar changeSearchText={setRestaurantGroupSearch} placeholder={'Search restaurant group'} isFetching={restaurantGroupFetching} />
                        {
                          restaurantGroups
                            ?.map((res) => (
                              <StyledMenuItem
                                key={res?.label}
                                value={res?.label}
                              >
                                {
                                  restaurantGroupId === res?.label ? <SelectedMenuItem data={res?.value} /> : res?.value
                                }
                              </StyledMenuItem>
                            ))
                        }
                        <DropdownInfiniteLoader
                          hasNextPage={hasNextRestaurantGroupsPage}
                          targetRef={restaurantGroupLoaderRef}
                        />
                      </Select>
                    </FormControl>

                    <FormControl
                      size="small"
                      sx={formControlStyles}
                    >
                      <StyledInputLabel>Restaurant</StyledInputLabel>
                      <Select
                        data-testid='restaurant-filter'
                        size="small"
                        label="Restaurant"
                        MenuProps={{ ...menuPropStyles, PaperProps: { ref: restaurantMenuRef } }}
                        sx={selectFieldStyles}
                        onChange={handleRestaurantChange}
                        multiple
                        onClose={() => setTimeout(() => setRestaurantSearch(''), 1000)}
                        value={restaurantIds || []}
                        renderValue={() => getRestaurantDisplayValue()}
                        endAdornment={
                          !hasSingleAvailableRestaurant && restaurantIds?.length > 0
                            ? (
                              <StyledFilterCancel>
                                <IconButton
                                  edge='end'
                                  size="small"
                                  disableRipple
                                  onClick={handleRestaurantClear}
                                >
                                  <ClearIcon sx={{ fontSize: '20px' }} />
                                </IconButton>
                              </StyledFilterCancel>
                            ) : null
                        }
                      >
                        <DropdownSearchBar changeSearchText={setRestaurantSearch} placeholder={'Search restaurant'} isFetching={restaurantFetching} />
                        {
                          restaurants
                            .map((res) => (
                              <StyledMenuItem
                                key={res?.id}
                                value={res?.id}
                              >
                                {
                                  restaurantIds.includes(res?.id) ? <SelectedMenuItem data={res?.name} /> : res?.name
                                }
                              </StyledMenuItem>
                            ))
                        }
                        <DropdownInfiniteLoader
                          hasNextPage={hasNextRestaurantsPage}
                          targetRef={restaurantLoaderRef}
                        />
                      </Select>
                    </FormControl>
                  </React.Fragment>
                )}
              </React.Fragment>
            </Box>
            <Box
              sx={actionGroupStyles}
            >
              {viewType === 'unignored' && (
                <ResetButton
                  onClick={handleReset}
                  status={isFetching}
                />
              )}

              <UpdateButton
                onClick={handleChange}
                filtersChanged={filtersChanged}
                status={isFetching}
              />
            </Box>
          </Box>
        </FilterContainer>
        <MenuHeading
          report={true}
          rightComponent={
            <StyledSearchBar
              value={nameSearch}
              placeholder="Search Employee"
              disabled={disableSearch}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                ),
              }}
              onChange={(e) => handleSearch(e.target.value)}
              autoComplete="off"
              inputProps={{ 'data-testid': 'employee-search-input' }}
            />
          }
        >
          Employees Without Number
        </MenuHeading>
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 1 }}>
          {viewType === "unignored" && (
            <StyledIgnoreButton
              variant="outlined"
              disableRipple
              disabled={superAdmin?.role !== 'admin' || selectedEmployeeIds.length === 0}
              onClick={() => setEmployeesToIgnore(selectedEmployees)}
              sx={{ width: 'auto', px: 2.5 }}
            >
              {selectedEmployeeIds?.length > 1 ? `Ignore Employees (${selectedEmployeeIds.length})` : 'Ignore Employee'}
            </StyledIgnoreButton>
          )}
        </Box>
        {
          viewType === 'ignored' ? (
            <IgnoredEmployees
              employeeNameSearch={debouncedNameSearch}
              onCountChange={setIgnoredEmployeeCount}
              onFetchingChange={setIsIgnoredEmployeesFetching}
            />
          ) : (
            (isFetching && !debouncedNameSearch) ? (
              <Loader />
            ) : (hasActiveEmployeeFilters && employee_visibility?.data ? (
              <IndexTable
                columns={columns}
                data={rows}
                tableId="employees-without-number-active"
                type="entries"
                checkboxWidth="10px"
                itemsPerPage={itemsPerPage}
                setItemsPerPage={setItemsPerPage}
                page={page}
                setPage={setPage}
                pageCount={employee_visibility?.pageCount}
                checkboxes={true}
                selectedIds={selectedEmployeeIds}
                setSelectedIds={setSelectedEmployeeIds}
                report={false}
                showDownloadButton={true}
                disableDownloadButton={employee_visibility?.data?.length === 0 || csvLoading}
                handleExportCsv={handleExportCsv}
                csvLoading={csvLoading}
                serverSort={true}
                sortBy={sortBy}
                sortOrder={sortOrder}
                defaultSortBy={sortBy}
                defaultSortOrder={sortOrder}
                onSort={handleSort}
                hasSearchTerm={Boolean(debouncedNameSearch)}
                searchLoading={isFetching}
              />) : (
              <Alert data-testid='filter-info' severity="info" sx={{ marginTop: '10px' }}>Select a restaurant group or restaurant</Alert>
            ))
          )
        }

        <Drawer
          sx={{
            width: drawerWidth,
            flexShrink: 0,
            '& .MuiDrawer-paper': {
              width: drawerWidth,
              marginTop: 'calc(35px * 2)',
            },
          }}
          variant="persistent"
          anchor="right"
          open={drawerOpen}
        >
          <StyledDiv>
            <StyledCreateTitle>Add Phone Number</StyledCreateTitle>

            <StyledFormContainer>
              <StyledFormField>
                <StyledFormFieldText>First Name</StyledFormFieldText>
                <StyledTextField
                  fullWidth
                  size="small"
                  value={employee?.first_name}
                  disabled={true}
                />
              </StyledFormField>

              <StyledFormField>
                <StyledFormFieldText>Last Name</StyledFormFieldText>
                <StyledTextField
                  fullWidth
                  size="small"
                  value={employee?.last_name}
                  disabled={true}
                />
              </StyledFormField>

              <StyledFormField>
                <StyledFormFieldText>Email</StyledFormFieldText>
                <StyledTextField
                  fullWidth
                  size="small"
                  value={employee?.email}
                  disabled={true}
                />
              </StyledFormField>

              <StyledFormField>
                <StyledFormFieldText>Restaurant</StyledFormFieldText>
                <StyledTextField
                  fullWidth
                  size='small'
                  value={employee?.restaurant_name}
                  disabled={true}
                />
              </StyledFormField>

              <StyledFormField>
                <StyledFormFieldText>Phone Number<span style={{ color: 'red' }}>*</span></StyledFormFieldText>
                <div style={{ display: 'flex', gap: '5px' }}>
                  <div style={{ width: '100%' }}>
                    <StyledPhoneField
                      value={phoneNumber}
                      onChange={(value) => {
                        setPhoneNumberError('')
                        setPhoneNumber(value)
                      }}
                      defaultCountry="us"
                      forceDialCode
                      borderColor={phoneNumberError ? "red" : "#c4c4c4"}
                      data-testid="create-phone"
                      searchCountry
                      disabled={networkGuestFetched}
                    />
                  </div>
                  {
                    networkGuestFetched ? (
                      <StyledCrossButton>
                        <ClearIcon
                          onClick={handleClearNetworkGuest}
                        />
                      </StyledCrossButton>
                    ) : (
                      <StyledSearchIconButton
                        onClick={searchNetworkGuest}
                        disabled={networkGuestFetchLoading}
                        disableRipple
                      >
                        <SearchIcon />
                      </StyledSearchIconButton>
                    )
                  }
                </div>
                <StyledHelperText>{phoneNumberError}</StyledHelperText>
              </StyledFormField>

              {
                networkGuestFetchLoading && (
                  <Loader />
                )
              }

              {
                networkGuestFetched && (
                  <>
                    <div style={{ marginTop: '3%' }}>
                      {
                        networkGuestExist ? (
                          <React.Fragment>
                            <Alert variant="outlined" severity="error">
                              This phone belongs to an employee record. Adding the same phone number would associate new record
                              with the already existing one.
                            </Alert>

                            <Box sx={{ mt: 2, minHeight: 200, marginBottom: '155px' }}>
                              {networkGuests.map((guest) => (
                                <StyledEmployeeDetails
                                  key={guest.id}
                                >
                                  <StyledInput
                                    type="radio"
                                    checked={selectedNetworkGuestIds.includes(guest.id)}
                                    onChange={() => {
                                      setSelectedNetworkGuestIds([guest.id]);
                                    }}
                                  />
                                  <Box sx={{ flex: 1 }}>
                                    <StyledTypography variant="body2" fontWeight="medium">
                                      {guest.first_name} {guest.last_name}
                                    </StyledTypography>
                                    <StyledTypography variant="caption" color="text.secondary" display="block">
                                      Email: {guest.email}
                                    </StyledTypography>
                                    {guest.phone_number && (
                                      <StyledTypography variant="caption" color="text.secondary" display="block">
                                        Phone: {guest.phone_number}
                                      </StyledTypography>
                                    )}
                                    {guest.employee_id && (
                                      <StyledTypography variant="caption" color="text.secondary" display="block">
                                        Employee ID: {guest.employee_id}
                                      </StyledTypography>
                                    )}
                                    {guest?.restaurants?.length > 0 && (
                                      <StyledTypography variant="caption" color="text.secondary" display="block">
                                        Active Restaurants: {guest.restaurants.map((res) => (
                                          res?.name)).join(', ')}
                                      </StyledTypography>
                                    )}
                                  </Box>
                                </StyledEmployeeDetails>
                              ))}
                            </Box>

                          </React.Fragment>
                        ) : (
                          <Alert variant="outlined" severity="info">
                            This phone does not belong to any employee record. Please proceed by adding the phone number to this employee.
                          </Alert>
                        )
                      }
                    </div>
                  </>
                )}
            </StyledFormContainer>
          </StyledDiv>

          <Paper
            sx={{
              position: 'fixed',
              bottom: 0,
              right: 0,
              width: drawerWidth,
              height: '70px'
            }}
            elevation={2}
          >
            <StyledButtonContainer>
              <StyledCancelButton
                onClick={handleDrawerClose}
                variant="outlined"
              >
                Cancel
              </StyledCancelButton>
              <StyledAddButton
                onClick={handleAdd}
                variant='contained'
                disabled={status || !networkGuestFetched}
              >
                {status ? <LoadingSpinner isLoading={true} /> : 'Add'}
              </StyledAddButton>
            </StyledButtonContainer>
          </Paper>
        </Drawer>
      </Box>

      {/* Failed restaurants modal */}
      <FailedRestaurantModal
        errorOpen={errorOpen}
        handleClose={handleClose}
        failedRestaurants={failedRestaurants}
        successfulRestaurantsCount={successfulRestaurantsCount}
      />

      <IgnoreEmployeeDialog
        open={employeesToIgnore.length > 0}
        employees={employeesToIgnore}
        loading={loading}
        onClose={() => setEmployeesToIgnore([])}
        onSubmit={handleIgnoreEmployee}
      />
    </React.Fragment>
  )
}
